module.exports = __webpack_public_path__ + "static/media/StylePhotography.28e51f8c.png";